import SalesforceIcon from '../../../assets/source/Salesforce.svg'
import GoogleSheets from '../../../assets/source/GoogleSheets.svg'
import HubspotIcon from '../../../assets/source/Hubspot.svg'
import PipedriveIcon from '../../../assets/source/PipedriveIcon.png'
import AttioIcon from '../../../assets/source/attio.webp'
import CopperIcon from '../../../assets/source/Copper.webp'
import CloseIcon from '../../../assets/source/close.svg'
import MondayIcon from '../../../assets/source/Monday.webp'
import LinkedInIcon from '../../../assets/source/LinkedIn.svg'
import AirtableIcon from '../../../assets/source/Airtable.svg'
import DatabaseBlack from '../../../assets/source/DatabaseBlack.svg'
import GoogleAnalyticsIcon from '../../../assets/source/google-analytics.svg'
import GoogleAdsIcon from '../../../assets/source/google-ads.svg'
import AmplitudeIcon from '../../../assets/source/amplitude.svg'
import ApolloIcon from '../../../assets/source/apollo.svg'
import QuickbooksIcon from '../../../assets/source/Quickbooks.svg'
import SharetribeIcon from '../../../assets/source/Sharetribe.webp'
import JiraIcon from '../../../assets/source/Jira.svg'
import TikTokIcon from '../../../assets/source/tiktok.png'
import OtherIcon from '../../../assets/source/Email.svg'
import CrystalReportsIcon from '../../../assets/source/CrystalReports.png'
import GongIcon from '../../../assets/source/GongIcon.png'
import MarketoIcon from '../../../assets/source/MarketoIcon.png'
import MetaIcon from '../../../assets/source/MetaIcon.svg'
import MicrosoftDynamicsIcon from '../../../assets/source/MicrosoftDynamics.png'
import PowerBIIcon from '../../../assets/source/PowerBI.png'
import MicrosoftSSRSIcon from '../../../assets/source/MicrosoftSSRS.svg'
import MLSIcon from '../../../assets/source/MLS.png'
import NetsuiteIcon from '../../../assets/source/Netsuite.svg'
import OutreachIcon from '../../../assets/source/Outreach.png'
import OracleBIIcon from '../../../assets/source/OracleBI.svg'
import WorkdayIcon from '../../../assets/source/Workday.png'
import SproutSocialIcon from '../../../assets/source/SproutSocial.png'
import TableauIcon from '../../../assets/source/Tableau.svg'
import YardiIcon from '../../../assets/source/Yardi.png'
import ZendeskIcon from '../../../assets/source/Zendesk.svg'
import MailerLiteIcon from '../../../assets/source/MailerLite.png'
import AsanaIcon from '../../../assets/source/asana.webp'
import IntercomIcon from '../../../assets/source/intercom.webp'
import ShopifyIcon from '../../../assets/source/shopify.webp'
import MailchimpIcon from '../../../assets/source/mailchimp.webp'
import CalendlyIcon from '../../../assets/source/calendly.webp'
import SquareIcon from '../../../assets/source/square.webp'

export const SOURCES_OPTIONS = [
    {
        name: 'Salesforce',
        icon: SalesforceIcon,
        backgroundColor: '#E6F4FB',
        step: 3,
        sourceValue: 'Salesforce',
        disabled: false,
    },
    {
        name: 'Google Sheets',
        icon: GoogleSheets,
        backgroundColor: '#E8F5EC',
        step: 2,
        sourceValue: 'GoogleSheets',
        disabled: false,
    },
    {
        name: 'HubSpot',
        icon: HubspotIcon,
        backgroundColor: '#FFF0EC',
        step: 3,
        sourceValue: 'HubSpot',
        disabled: false,
    },
    {
        name: 'Pipedrive',
        icon: PipedriveIcon,
        backgroundColor: '#E8F5EC',
        step: 3,
        sourceValue: 'Pipedrive',
        disabled: false,
    },
    {
        name: 'Attio',
        icon: AttioIcon,
        backgroundColor: '#E8F5EC',
        step: 2,
        sourceValue: 'Attio',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Copper',
        icon: CopperIcon,
        backgroundColor: '#E8F5EC',
        step: 2,
        sourceValue: 'Copper',
        disabled: false,
    },
    {
        name: 'Close',
        icon: CloseIcon,
        backgroundColor: '#FFF0EC',
        step: 2,
        sourceValue: 'Close',
        disabled: false,
    },
    {
        name: 'Monday',
        icon: MondayIcon,
        backgroundColor: '#FFF0EC',
        step: 2,
        sourceValue: 'Monday',
        preferredSpelling: 'monday.com',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'LinkedIn',
        icon: LinkedInIcon,
        backgroundColor: '#FFF0EC',
        step: 1,
        sourceValue: 'LinkedIn',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Airtable',
        icon: AirtableIcon,
        backgroundColor: '#F0F0F0',
        step: 2,
        sourceValue: 'Airtable',
        disabled: false,
    },
    {
        name: 'Database',
        icon: DatabaseBlack,
        backgroundColor: '#F0F0F0',
        step: 1,
        sourceValue: 'Database',
        disabled: false,
    },
    {
        name: 'Google Analytics',
        icon: GoogleAnalyticsIcon,
        backgroundColor: '#E8F1FE',
        step: 2,
        sourceValue: 'GoogleAnalytics',
        disabled: false,
    },
    {
        name: 'Google Ads',
        icon: GoogleAdsIcon,
        backgroundColor: '#E8F1FE',
        step: 2,
        sourceValue: 'GoogleAds',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Amplitude',
        icon: AmplitudeIcon,
        backgroundColor: '#E8F1FE',
        step: 2,
        sourceValue: 'Amplitude',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Apollo',
        icon: ApolloIcon,
        backgroundColor: '#E8F1FE',
        step: 3,
        sourceValue: 'Apollo',
        disabled: false,
    },
    {
        name: 'Quickbooks',
        icon: QuickbooksIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Quickbooks',
        preferredSpelling: 'QuickBooks',
        // for now, leave this as off, unless QB fights us hard on this (gj 11/25)
        allowSingleInstall: false,
        disabled: false,
    },
    {
        name: 'Sharetribe',
        icon: SharetribeIcon,
        backgroundColor: '#E8F1FE',
        step: 1,
        sourceValue: 'Sharetribe',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Jira',
        icon: JiraIcon,
        backgroundColor: '#F0F0F0',
        step: 2,
        sourceValue: 'Jira',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'TikTok',
        icon: TikTokIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'TikTok',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'MailerLite',
        icon: MailerLiteIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'MailerLite',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Asana',
        icon: AsanaIcon,
        backgroundColor: '#FCE8E8',
        step: 2,
        sourceValue: 'Asana',
        disabled: false,
    },
    {
        name: 'Intercom',
        icon: IntercomIcon,
        backgroundColor: '#E8F4FD',
        step: 2,
        sourceValue: 'Intercom',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Shopify',
        icon: ShopifyIcon,
        backgroundColor: '#F0F5E6',
        step: 2,
        sourceValue: 'Shopify',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Calendly',
        icon: CalendlyIcon,
        backgroundColor: '#E6F0FF',
        step: 2,
        sourceValue: 'Calendly',
        disabled: false,
    },
    {
        name: 'Mailchimp',
        icon: MailchimpIcon,
        backgroundColor: '#FFF9E0',
        step: 2,
        sourceValue: 'Mailchimp',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Square',
        icon: SquareIcon,
        backgroundColor: '#F0F0F0',
        step: 2,
        sourceValue: 'Square',
        disabled: false,
    },
    {
        name: 'Other',
        icon: OtherIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'Other',
        disabled: false,
    },
    {
        name: 'Crystal Reports',
        icon: CrystalReportsIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'CrystalReports',
        emailRedirect: true,
    },
    {
        name: 'Gong',
        icon: GongIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'Gong',
        disabled: true,
    },
    {
        name: 'Marketo',
        icon: MarketoIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'Marketo',
        disabled: true,
    },
    {
        name: 'Meta Ads',
        icon: MetaIcon,
        backgroundColor: '#E6F4FB',
        step: 2,
        sourceValue: 'Meta',
        disabled: false,
        adminOnly: true,
    },
    {
        name: 'Microsoft Dynamics',
        icon: MicrosoftDynamicsIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'MicrosoftDynamics',
        disabled: true,
    },
    {
        name: 'Power BI',
        icon: PowerBIIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'PowerBI',
        disabled: true,
    },
    {
        name: 'Microsoft SSRS',
        icon: MicrosoftSSRSIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'MicrosoftSSRS',
        emailRedirect: true,
    },
    {
        name: 'MLS Realtor',
        icon: MLSIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'MLS',
        disabled: true,
    },
    {
        name: 'Netsuite',
        icon: NetsuiteIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'Netsuite',
        disabled: true,
    },
    {
        name: 'Outreach',
        icon: OutreachIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'Outreach',
        disabled: true,
    },
    {
        name: 'Oracle BI',
        icon: OracleBIIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'OracleBI',
        disabled: true,
    },
    {
        name: 'Workday',
        icon: WorkdayIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'Workday',
        disabled: true,
    },
    {
        name: 'Sprout Social',
        icon: SproutSocialIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'SproutSocial',
        disabled: true,
    },
    {
        name: 'Tableau',
        icon: TableauIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'Tableau',
        disabled: true,
    },
    {
        name: 'Yardi',
        icon: YardiIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'Yardi',
        emailRedirect: true,
    },
    {
        name: 'Zendesk',
        icon: ZendeskIcon,
        backgroundColor: '#E6F4FB',
        step: 1,
        sourceValue: 'Zendesk',
        disabled: true,
    },
]
